
import {extend} from "./utility";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

const marquee = (eleSelector, opts) => {
    let defaults = {
        speed: 100,
        reverse:false,
        pauseOnHover: false,
    };
    let options = extend(defaults, opts);
    let elems = document.querySelectorAll(eleSelector);

    const makeClone = (cElem,pElem) =>{
        // make clone of the element
        let clone = cElem.cloneNode(true);
        pElem.appendChild(clone);
    };

    elems.forEach((marqueeWrapper,index) => {
        if(!marqueeWrapper){ return; }

        let marquee = marqueeWrapper.parentElement;
        let marqueeList = marqueeWrapper.children;
        let distance =  marqueeList[0].clientWidth;

        let i = 0;
        while (i < marquee.clientWidth) {
            makeClone(marqueeList[0],marqueeWrapper);
            i += distance;
        }
        let time = distance / options.speed;

        marqueeWrapper.style.width =  distance + "px";

        if(options.reverse){
            marqueeWrapper.style.direction = "rtl";
        }
        else{
            distance = '-'+ distance;
        }

        let myAnimation = gsap.to(marqueeWrapper, time,{
            scrollTrigger: marquee,
            repeat: -1,
            x: distance,
            ease: "none"
        });
        if(options.pauseOnHover){
            marquee.addEventListener('mouseenter', (event) => {
                myAnimation.pause();
            });
            marquee.addEventListener('mouseleave', (event) => {
                myAnimation.play();
            });
        }
    });
};

export default marquee;
